import { App } from './models';
import { getPlatform } from '../../../utils';
const app: App = {
    platform: getPlatform(),
}

export default app